

























	import { Vue, Component } from 'vue-property-decorator';

	import MainMenu from '@/components/MainMenu.vue';
	import OutlineButton from '@/components/Common/OutlineButton.vue';
	import PhoneHeader from "@/components/Common/PhoneHeader.vue";
	import Footer from '@/components/Common/Footer.vue';
	import Slider from "@/components/Home/Slider.vue";

	import Loader from "@/components/Common/Loader.vue";
	import Empty from "@/components/Common/Empty.vue";
	Vue.component("Loader", Loader);
	Vue.component("Empty", Empty);

	@Component({
		components:{
            Slider,
            MainMenu,
		    OutlineButton,
			PhoneHeader,
            Footer,
		}
	})
	export default class App extends Vue {
        goToContacts(){
            this.$router.push("/page/contacts");
		}
	}
